/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthNoteHistoryResponse } from './PalReauthNoteHistoryResponse';
import {
    PalReauthNoteHistoryResponseFromJSON,
    PalReauthNoteHistoryResponseFromJSONTyped,
    PalReauthNoteHistoryResponseToJSON,
    PalReauthNoteHistoryResponseToJSONTyped,
} from './PalReauthNoteHistoryResponse';

/**
 * 
 * @export
 * @interface GetPalReauthNoteHistory200Response
 */
export interface GetPalReauthNoteHistory200Response {
    /**
     * 
     */
    data?: PalReauthNoteHistoryResponse;
}

/**
 * Check if a given object implements the GetPalReauthNoteHistory200Response interface.
 */
export function instanceOfGetPalReauthNoteHistory200Response(value: object): value is GetPalReauthNoteHistory200Response {
    return true;
}

export function GetPalReauthNoteHistory200ResponseFromJSON(json: any): GetPalReauthNoteHistory200Response {
    return GetPalReauthNoteHistory200ResponseFromJSONTyped(json, false);
}

export function GetPalReauthNoteHistory200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPalReauthNoteHistory200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PalReauthNoteHistoryResponseFromJSON(json['data']),
    };
}

export function GetPalReauthNoteHistory200ResponseToJSON(json: any): GetPalReauthNoteHistory200Response {
    return GetPalReauthNoteHistory200ResponseToJSONTyped(json, false);
}

export function GetPalReauthNoteHistory200ResponseToJSONTyped(value?: GetPalReauthNoteHistory200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PalReauthNoteHistoryResponseToJSON(value['data']),
    };
}

